import { Archive, ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

/**
 * Check if the currently selected event is archived.
 */
export function useIsArchived() {
  return localStorage.getItem('selectedEventArchived') === 'true';
}

/**
 * Banner shown at the top of pages when viewing an archived event.
 */
export function ArchivedBanner() {
  const navigate = useNavigate();
  return (
    <div className="mb-4 flex items-center gap-3 bg-amber-500/10 border border-amber-500/30 text-amber-200 rounded-lg px-4 py-3" data-testid="archived-banner">
      <Archive className="h-5 w-5 shrink-0 text-amber-400" />
      <div className="flex-1">
        <p className="font-semibold text-sm">Arkiveret event &mdash; read-only</p>
        <p className="text-xs text-amber-300/70">Ændringer er deaktiveret. Genaktiver eventet for at redigere.</p>
      </div>
      <Button variant="outline" size="sm" onClick={() => navigate('/')} className="border-amber-500/30 text-amber-300 hover:bg-amber-500/20 shrink-0" data-testid="back-from-archived-btn">
        <ChevronLeft className="h-4 w-4 mr-1" /> Dashboard
      </Button>
    </div>
  );
}
